import { render, staticRenderFns } from "./FrmItemDetailGroup.vue?vue&type=template&id=1764d3dd&scoped=true"
import script from "./FrmItemDetailGroup.vue?vue&type=script&lang=js"
export * from "./FrmItemDetailGroup.vue?vue&type=script&lang=js"
import style0 from "./FrmItemDetailGroup.vue?vue&type=style&index=0&id=1764d3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1764d3dd",
  null
  
)

export default component.exports